<template>
<div>
  <v-data-table ref="allNeeds"
    v-if="!display"
    class="ex-product-table"
    :headers="headers"
    :items="needs"
    sort-icon="icon-angle-down-18"
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <td class="text-xs-center image-td">
        <img class="tableImg" v-if="props.item.image" :src="apiUrl + props.item.image" alt="image"/>
        <span v-else>{{$t('products.no_image')}}</span>
      </td>
      <td class="text-xs-left">
          {{ props.item.ProductTranslations[0].name }}
      </td>
      <td class="text-xs-left">
          {{ props.item.phoneNumber}}
      </td>
      <td class="text-xs-left">
            <span v-if="props.item.Category && props.item.Category.status === 1" slot="activator" class="mb-0">{{ props.item.Category.CategoryTranslations[0].name }}</span>
      </td>
      <td class="text-xs-center">
            <span slot="activator" class="mb-0">{{ props.item.ProductTranslations[0].description.length > 75 ? props.item.ProductTranslations[0].description.substring(0, 225) + '...' : props.item.ProductTranslations[0].description  }}</span>
      </td>
      <td class="text-xs-center">
        <a v-if="props.item.options.donateCount" href="" @click = "$router.push('/products/' + props.item.id + '/' + props.item.ProductTranslations[0].name.replace(/\s+/g, '-'))">{{ props.item.options.donateCount }}</a>
      </td>
      <td class="action-icons-sect">
        <div class="d-flex justify-space-around layout">
          <v-icon @click="editItem(props.item)" class="ex-edit-icon"> icon-edit-profile</v-icon>
          <v-icon @click="deleteModal(props.item)" class="ex-delete-icon">icon-delete</v-icon>
        </div>
      </td>

    </template>
  </v-data-table>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('products.delete_product')}}</span>
      </v-card-title>
      <v-card-text>
        <v-flex>
          <p class="p-14">{{$t('products.delete_product_text')}}</p>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="g-btn-default g-btn-135 m-0-5" @click.native="closeModal">{{$t('products.cancel')}}</v-btn>
        <v-btn class="g-btn-main-light g-btn-135 m-0-5" @click.native="deleteNeed">{{$t('products.delete')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <div id="comp-render" v-if="display">
    <add-needs :currentProduct="currentProduct" @edit="edit"></add-needs>
  </div>
</div>
</template>

<script>
import AddNeeds from '../AddNeeds'
export default {
  name: 'AllNeeds',
  components: {
    AddNeeds
  },
  data: () => ({
    apiUrl: process.env.ROOT_API,
    needs: [],
    dialog: false,
    display: false,
    currentProduct: {}
  }),
  methods: {
    edit () {
      this.display = false
      this.getNeeds()
    },
    editItem (currentProduct) {
      this.currentProduct = currentProduct
      this.display = true
      // this.$router.push({name: 'AddNeeds', params: { currentProduct: currentProduct }})
    },
    getNeeds () {
      this.$store.dispatch('products/getNeeds').then((res) => {
        this.needs = res.data.products
      }).catch(console.error)
    },
    deleteModal (item) {
      this.deleteItem = item
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
    },
    deleteNeed () {
      if (this.deleteItem) {
        this.dialog = false
        this.$store.dispatch('profile/deleteProduct', this.deleteItem.id).then((res) => {
          if (res) {
            this.getNeeds()
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('products.image'), value: 'image', sortable: false },
        { text: this.$t('settings.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('settings.phone'), align: '', value: 'phone', sortable: false },
        { text: this.$t('products.category'), align: '', value: 'category', sortable: false },
        { text: this.$t('products.description'), value: 'description' },
        { text: this.$t('products.need_count'), value: 'donateCount' },
        { text: this.$t('settings.actions'), align: 'center', value: 'actions', sortable: false }

      ]
    }
  },
  created () {
    this.getNeeds()
  },
  mounted () {
    this.$refs.allNeeds.$el.querySelector('.v-table__overflow').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.allNeeds.$el.querySelector('.v-table__overflow').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/desktop/addProduct";
.image-td{
  height: 65px;
  width:86.5px;
  padding:5px 0 !important;
  margin-right: 0 !important;
  @media (max-width: $screen-xs) {
    padding:5px !important;
  }
  .tableImg {
    width: 75px;
  }
}
.ex-rel-dropzone{
  & /deep/ .dz-preview.dz-success .dz-success-mark{
    animation: passing-through 1s cubic-bezier(0.77,0,0.175,1) !important;
  }
}
.ex-rel-dropzone{
  & /deep/ .dz-preview.dz-error .dz-error-mark{
    animation: slide-in 1s cubic-bezier(0.77,0,0.175,1) !important;
  }
}
.isAdmin {
  padding-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/AllNeeds.vue